import React from 'react';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { User } from '~/eds/src/types/User';
import { UserAction } from '~/eds/src/types/UserAction';
import { typedMemo } from '~/eds/src/utils/typedMemo';

import { FeedbackDetails, Message as MessageType } from '../types/chat';
import { AiMessage } from './AiMessage';
import { UserMessage } from './UserMessage';

interface Props {
  message: MessageType;
  user: User;
  onChoose: (message: MessageType, choice: string) => void;
  onSelectSource: (message: MessageType, sourceIndex: number) => void;
  onSubmitFeedback: (
    message: MessageType,
    feedbackDetails: FeedbackDetails,
  ) => void;
  disableChoices?: boolean;
  isLoading?: boolean;
  isReplying?: boolean;
  messageActions?: UserAction[];
  shouldShowActions?: boolean;
  thinkingEvents?: string[];
  userMessageActions?: UserAction[];
}

export const Message = typedMemo(
  ({
    disableChoices,
    isLoading,
    isReplying,
    message,
    messageActions = [],
    thinkingEvents,
    shouldShowActions = true,
    user,
    userMessageActions,
    onChoose,
    onSelectSource,
    onSubmitFeedback,
  }: Props) => {
    const { userType } = message;
    return (
      <Layout
        direction="column"
        px={6}
        py={2}
        mx={1}
        spacing={4}
        className={userType}
        bg={isReplying ? 'background.ai' : undefined}
        borderRadius="l"
      >
        {message.userType === 'current' ? (
          <UserMessage
            message={message}
            actions={userMessageActions}
            user={user}
          />
        ) : (
          <AiMessage
            user={user}
            message={message}
            messageActions={messageActions}
            onChoose={onChoose}
            onSubmitFeedback={onSubmitFeedback}
            disableChoices={disableChoices}
            onSelectSource={onSelectSource}
            isReplying={isReplying}
            isLoading={isLoading}
            thinkingEvents={thinkingEvents}
            shouldShowActions={shouldShowActions}
          />
        )}
      </Layout>
    );
  },
);
